// src/features/participants/page/Provider

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { ProviderType } from '../../types/providersTypes';
import { useTranslation } from 'react-i18next';

const Provider = () => {
    const { t, i18n } = useTranslation();
    // Define columns for the Provider table
    const ProviderTypeColumns: ColumnsType<ProviderType> = [
        { title: "Name", dataIndex: "name", key: "name", sorter: true },
        { title: "Description", dataIndex: "description", key: "description" },
        //{
        //    title: "Status",
        //    dataIndex: "status",
        //    key: "status",
        //    render: (status?: number) => {
        //        const statusMap: Record<number, { label: string; color: string }> = {
        //            1: { label: "Active", color: "green" },
        //            2: { label: "Inactive", color: "red" },
        //            3: { label: "Draft", color: "gold" },
        //        };
        //        const statusInfo = statusMap[status ?? 0];
        //        return (
        //            <Tag color={statusInfo?.color || "default"}>
        //                {statusInfo?.label || "Unknown"}
        //            </Tag>
        //        );
        //    },
      /*  },*/
    ];

    return (
        <div>
            <DynamicTable<ProviderType> // Ensure generic type matches the data
                dataApiUrl={API_ENDPOINTS.PROVIDERS.SEARCH_PROVIDERTYPE} // Your API endpoint for fetching menus
                baseQueryKey={QUERY_KEYS.PROVIDERS.PROVIDERTYPE} // Unique query key for menus
                columns={ProviderTypeColumns}
                tableTitle={"Provider Type"}
                showActions={true} // Set to true if you want Edit/Delete actions
                deleteBaseUrl={API_ENDPOINTS.PROVIDERS.DELETE_PROVIDERTYPE}
                deletePayloadField="name"
                // Pass the fields you want the search bar to filter
                filterConfigs={[
                    { field: "name", placeholder: t("Search by Provider Type name") },
                    {
                        field: "Print",
                        type: "export",
                        exportOptions: {
                            url: API_ENDPOINTS.PROVIDERS.EXPORT_PROVIDERTYPE,
                            fileName: "ProviderTypes",
                            fileType: "excel", // "csv" 
                            defaultPayload: {},
                            columns: [
                                { header: "Name", key: "name" },
                                { header: "Description", key: "description" },
                            ]
                        }
                    }

                ]}
            />
        </div>
    );
};

export default Provider;